import React, { useState, useEffect, useContext } from "react";
import {
  Input,
  InputNumber,
  Table,
  Form,
  Typography,
  Popconfirm,
  message,
  Select,
} from "antd";
import "./auditforms.css";
import { Link, useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import HandleSearch from "../../../utils/CommonSearchComponent";
import APICaller from "../../../utils/APICaller";
import BeforeTableHeader from "../../layouts/beforeTableHeader";
import CustomLoader from "../../common/customLoader";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  statuses,
  ...restProps
}) => {
  let inputNode;
  if (dataIndex === "status") {
    inputNode = (
      <Select
        showSearch
        allowClear
        options={statuses}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
      />
    );
  } else {
    inputNode = inputType === "number" ? <InputNumber /> : <Input />;
  }
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const AuditForms = ({ children }) => {
  const [tableForm] = Form.useForm();
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const [showLoader, setShowLoader] = useState(true);
  const location = useLocation();
  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const slsLIUId = secureLocalStorage.getItem("lIUId");
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [statuses, setStatuses] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" },
  ]);
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      const selectedRowKeysChildInfoArr = selectedRows.map((row) => row.key);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };
  const additionalColumns = [];
  const columns = [
    {
      title: () => {
        return <div className="tableTitle"> ID</div>;
      },
      dataIndex: "id",
      render: (text) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle"> Form Name</div>;
      },
      dataIndex: "form_name",
      render: (text, row) => (
        <Link
          to={"/auditForms/" + row.key}
          state={{
            route: location.pathname,
            auditFormHasWeightage: row.hasWeightage,
          }}
          style={{ color: "black" }}
          onClick={() => {
            secureLocalStorage.setItem("fromComponent", "auditForms");
          }}
        >
          <span className="rowstyle" style={{ color: "#1875CB" }}>
            {text}
          </span>
        </Link>
      ),
    },
    {
      title: () => {
        return <div className="tableTitle"> Total Audits</div>;
      },
      dataIndex: "total_audits",
      width: "10%",
      render: (text) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle"> Active Audits</div>;
      },
      dataIndex: "active_audits",
      width: "10%",
      render: (text) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle"> Status</div>;
      },
      dataIndex: "status",
      width: "10%",
      editable: true,
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: () => {
        return <div className="tableTitle"> Created At</div>;
      },
      dataIndex: "createdAt",
      width: "15%",
      render: (text) => <span className="rowstyle">{text}</span>,
    },
  ];
  (slsRole === process.env.REACT_APP_AROLE ||
    slsRole === process.env.REACT_APP_QC) &&
    additionalColumns.push(
      {
        title: () => {
          return <div className="tableTitle"> Updated At</div>;
        },
        dataIndex: "updatedAt",
        width: "15%",
      },
      {
        title: () => {
          return <div className="tableTitle"> Action</div>;
        },
        dataIndex: "action",
        width: "10%",
        render: (_, record) => {
          const editable = isEditing(record);
          return editable ? (
            <span>
              <Typography.Link
                onClick={() => save(record.key)}
                style={{
                  marginRight: 8,
                }}
              >
                Save
              </Typography.Link>
              <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                <a>Cancel</a>
              </Popconfirm>
            </span>
          ) : (
            <>
              <Link
                to={"/auditForms/edit/" + record.key}
                state={{
                  route: location.pathname,
                  auditFormHasWeightage: record.hasWeightage,
                }}
                style={{ color: "black" }}
                onClick={() => {
                  secureLocalStorage.setItem("fromComponent", "auditForms");
                }}
              >
                <span className="auditFormEditIcon">Edit</span>
              </Link>
            </>
          );
        },
      }
    );
  columns.push(...additionalColumns);
  const mergedColumns =
    columns &&
    columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: "text",
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
          statuses: statuses,
        }),
      };
    });
  const [selectionType, setSelectionType] = useState("checkbox");

  /*begin::getAuditFormList will fetch list of audits*/
  const [list, setList] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 100 });
  const getAuditFormList = async (source = "", pagination = "") => {
    let hasSearchedValue, searchKeyword;
    if (secureLocalStorage.getItem("hasSearchedValue")) {
      hasSearchedValue = "yes";
      searchKeyword = secureLocalStorage.getItem("searchKeyword");
    } else {
      hasSearchedValue = "";
      searchKeyword = "";
    }
    const searchIn = location.pathname.replace("/", "");
    const callActionFrom = source ? source : "";
    const globalStates = {
      globalState: globalState,
      setGlobalState: setGlobalState,
    };
    const { current, pageSize } = pagination;

    const allStates = {
      showLoader: showLoader,
      setShowLoader: setShowLoader,
      pagination: pagination
        ? pagination
        : { current: 1, page: 1, pageSize: 100 },
      setPagination: setPagination,
      list: list,
      setList: setList,
    };

    await HandleSearch(
      hasSearchedValue,
      searchIn,
      searchKeyword,
      callActionFrom,
      globalStates,
      allStates
    );
  };

  const handleTableChange = async (pagination) => {
    const { current, pageSize } = pagination;
    getAuditFormList(current, pageSize);
  };
  useEffect(() => {
    getAuditFormList();
  }, [globalState.isTokenUpdate && globalState.isTokenUpdate === true]);
  /*end::getAuditFormList will fetch list of audits*/

  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    tableForm.setFieldsValue({
      status: "",
      createdAt: "",
      updatedAt: "",
      ...record,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const save = async (key) => {
    try {
      const row = await tableForm.validateFields();
      const newData = globalState.list;
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];

        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        setEditingKey("");

        const endpoint = "/auditForms/" + key;
        const method = "PUT";
        const payload = {
          status: newData[index]?.status,
          historySource: "backend",
          historyAction: "update",
          historyUserID: slsLIUId,
        };
        APICaller(slsRole, slsToken, endpoint, method, payload)
          .then((response) => {
            message.success("AuditForm updated successfully.");
            tableForm.resetFields();
            getAuditFormList();
          })
          .catch((error) => {});
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };
  return (
    <>
      <div className="all-content">
        <BeforeTableHeader
          list={list && list.length}
          showListingCount="yes"
          href={
            secureLocalStorage.getItem("role") === "admin" ||
            secureLocalStorage.getItem("role") === "qc"
              ? "/auditForms/add"
              : ""
          }
        />
        <div className="all-table-holder">
          <CustomLoader showLoader={showLoader} />

          <Form form={tableForm} component={false}>
            <Table
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              bordered
              columns={mergedColumns}
              // rowSelection={{
              //   type: selectionType,
              //   ...rowSelection,
              // }}
              //columns={columns}
              dataSource={globalState?.list}
              // pagination={globalState?.pagination}
              // onChange={(e) => {
              //   getAuditFormList("pagination", e);
              // }}
              rowClassName="editable-row"
              pagination={{
                onChange: cancel,
              }}
            />
          </Form>
        </div>
      </div>
    </>
  );
};
export default AuditForms;
